import React from 'react'
import { ApolloProvider } from './providers'
import { MixpanelProvider } from 'react-mixpanel-browser'
import { LocationProvider } from '@reach/router'
import { ResetStoresOnRouteChange } from './components/resetStoresOnRouteChange'
import { GoogleOAuthProvider } from '@react-oauth/google'
const wrapRootElement = ({ element }) => {
  return (
    <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
      <ApolloProvider>
        <MixpanelProvider>
          <LocationProvider>
            <ResetStoresOnRouteChange>{element}</ResetStoresOnRouteChange>
          </LocationProvider>
        </MixpanelProvider>
      </ApolloProvider>
    </GoogleOAuthProvider>
  )
}

export default wrapRootElement
